import React from 'react';

// URL ufficiali del podcast "Resta in Pace — Voci nel Lutto"
export const APPLE_PODCAST_URL = 'https://podcasts.apple.com/it/podcast/id1896762533';
export const SPOTIFY_SHOW_URL = 'https://open.spotify.com/show/033gzN9cc4YbtABRzKkLgS';

const AppleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 4.5c1.38 0 2.5 1.12 2.5 2.5S13.38 9.5 12 9.5 9.5 8.38 9.5 7s1.12-2.5 2.5-2.5zm0 6.5c2.485 0 4.5 2.015 4.5 4.5v3c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5v3c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-2.485 2.015-4.5 4.5-4.5zm-5.5 4c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1v-3zm10 0c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1v-3z"/>
  </svg>
);

const SpotifyIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12C24 5.4 18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z"/>
  </svg>
);

/**
 * PodcastBadges — badge "Ascolta su Apple Podcasts" + "Ascolta su Spotify".
 * Riutilizzabile (homepage, pagine SEO, ecc.).
 */
const PodcastBadges = ({ className = '', size = 'md' }) => {
  const pad = size === 'lg' ? 'px-6 py-3 text-base' : 'px-5 py-2.5 text-sm';
  return (
    <div className={`flex flex-wrap items-center justify-center gap-3 ${className}`} data-testid="podcast-badges">
      <a
        href={APPLE_PODCAST_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Ascolta su Apple Podcasts"
        className={`inline-flex items-center gap-2 rounded-full font-bold text-white shadow-sm transition-all hover:scale-105 bg-gradient-to-br from-[#A24BFF] to-[#FF2D55] hover:opacity-95 ${pad}`}
        data-testid="badge-apple-podcasts"
      >
        <AppleIcon />
        Ascolta su Apple Podcasts
      </a>
      <a
        href={SPOTIFY_SHOW_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Ascolta su Spotify"
        className={`inline-flex items-center gap-2 rounded-full font-bold text-white shadow-sm transition-all hover:scale-105 bg-[#1DB954] hover:bg-[#1ed760] ${pad}`}
        data-testid="badge-spotify"
      >
        <SpotifyIcon />
        Ascolta su Spotify
      </a>
    </div>
  );
};

export default PodcastBadges;
